import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  q: 'Qu’est-ce que je reçois exactement avec l’achat ?',
  a: 'Vous obtenez un accès immédiat à plus de 100 guides étape par étape de projets de robots au format PDF, ainsi qu’aux 3 bonus : le Pack Arcade en carton, Le guide des bricolages en papier en 5 minutes et Petits créateurs : slime et jeux sensoriels. Tout est livré au format numérique — sans livraison et sans attente.',
  tone: 'bg-sky-light'
}, {
  q: 'Quels matériaux dois-je acheter ?',
  a: 'Vous avez déjà chez vous presque tout ce qu’il faut — boîtes en carton, bouteilles en plastique, ruban adhésif, élastiques, bouchons de bouteille, stylos et ciseaux. Chaque projet indique clairement à l’avance le matériel nécessaire, pour éviter les surprises.',
  tone: 'bg-sunshine-light'
}, {
  q: 'À quel âge s’adresse MakerLab ?',
  a: 'MakerLab est conçu pour les enfants de 4 à 12 ans. Les projets sont classés par difficulté : les plus faciles sont parfaits pour les plus petits avec un peu d’aide des parents, tandis que les projets avancés sont idéaux pour les plus grands qui veulent un vrai défi d’ingénierie.',
  tone: 'bg-brand-light'
}, {
  q: 'Mon enfant a-t-il besoin d’une expérience préalable ?',
  a: 'Absolument pas. Chaque projet part de zéro — entièrement illustré, étape par étape et rédigé dans un langage simple que tout enfant peut suivre. Aucune connaissance en robotique, en programmation ni compétence technique n’est nécessaire. Juste de la curiosité et deux mains.',
  tone: 'bg-mint-light'
}, {
  q: 'Comment accéder à mon achat ?',
  a: 'Juste après l’achat, vous recevrez un e-mail avec un lien de téléchargement. Vous pouvez accéder à vos fichiers depuis n’importe quel appareil — téléphone, tablette ou ordinateur. Les PDF peuvent être ouverts, enregistrés et imprimés autant de fois que vous le souhaitez.',
  tone: 'bg-coral-light'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-41" data-mp="1po1jhcwmvbgl">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-42" data-mp="1ks2xtx2ow7jv">
        <SectionHeading eyebrow="Des questions ?" title={<>Questions fréquentes</>} subtitle="Tout ce que vous devez savoir avant de commencer." data-id="element-43" data-mp="1fryhc71s7ctn" />
        <div className="mt-12 space-y-3" data-id="element-44" data-mp="2ddmbelarlj20">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className={`overflow-hidden rounded-2xl border border-ink/10 ${f.tone}`} data-id="element-45" data-mp="23gzs40y37023" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-46" data-mp="1zfny7j86jso3">
                  <span className="font-display text-base font-bold text-ink sm:text-lg" data-id="element-47" data-mp="2zpfaodhetsqk">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-48" data-mp="33nd09hf3eguh" />
                </button>
                <AnimatePresence initial={false} data-id="element-49" data-mp="3ifex0slv8tqa">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-50" data-mp="3ndgi1j2ur34e">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-ink/60" data-id="element-51" data-mp="11r47ud6a9pn2">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}